module.exports = __webpack_public_path__ + "static/media/programowanie-dla-dzieci.73894481.png";